import { StatItem } from "@components/Listings/DealScoreDialog/StatItem"
import Image from "next/image"
import LightIcon from "@components/Listings/DealScoreDialog/icons/Lighthouse.png"
import { Listing } from "@t/Listing"

export function OldKeyWestStats({ listing }: { listing: Listing }) {
    if (listing.resort?.id !== 11) {
        return null
    }
    const text =
        listing.deed_exp === 2057 ? (
            <>
                This Old Key West listing has a special <strong>extended 2057 deed</strong>. We’ve taken the extra years into account when calculating its score.
            </>
        ) : (
            <>This Old Key West DOES NOT have an extended 2057 deed. We’ve taken this into account when comparing it to category peers.</>
        )
    return (
        <StatItem image={<Image src={LightIcon} alt="OKW Deed" width={40} height={40} />} imgText="OKW Deed">
            {text}
        </StatItem>
    )
}
